import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private title = new Subject<string>();
  title$ = this.title.asObservable();

  constructor() { }

  setTitle(title: string) {
    this.title.next(title);
  }
}
